"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var abstract_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/abstract_input_store"));
var input_option_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/input_option_store"));
var containsValue = function (value) { return function (option) {
    var _a;
    return (String(option.value) === value || Boolean((_a = option.options) === null || _a === void 0 ? void 0 : _a.some(containsValue(value))));
}; };
var SelectInputStore = /** @class */ (function (_super) {
    __extends(SelectInputStore, _super);
    function SelectInputStore(component, props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event) {
            _this.value = event.target.value;
        };
        var options = props.options, defaultValue = props.defaultValue;
        _this.component = component;
        _this.onChange = props.onChange;
        _this.optionStores = props.options.map(function (opt) { return new input_option_store_1.default(opt); });
        if (defaultValue) {
            _this.value = defaultValue;
        }
        // Track both value and importCategoryId changes
        (0, mobx_1.reaction)(function () {
            var selectedOption = _this.optionStores.find(function (opt) { return opt.value === _this.value; });
            return { value: _this.value, importCategoryId: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.importCategoryId };
        }, function (_a) {
            var _b, _c;
            var value = _a.value, importCategoryId = _a.importCategoryId;
            if (!value) {
                (_b = _this.onChange) === null || _b === void 0 ? void 0 : _b.call(_this, undefined);
            }
            else if (importCategoryId !== undefined) {
                (_c = _this.onChange) === null || _c === void 0 ? void 0 : _c.call(_this, [importCategoryId, value]);
            }
        }, defaultValue ? { fireImmediately: true } : undefined);
        return _this;
    }
    Object.defineProperty(SelectInputStore.prototype, "className", {
        get: function () {
            return (0, classnames_1.default)('estimateForm-SingleSelect', {
                'estimateForm-SingleSelect-checked': this.valid
            });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], SelectInputStore.prototype, "optionStores", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SelectInputStore.prototype, "className", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SelectInputStore.prototype, "handleChange", void 0);
    return SelectInputStore;
}(abstract_input_store_1.default));
exports.default = SelectInputStore;
